import { render, staticRenderFns } from "./joinus.vue?vue&type=template&id=99f856e2&scoped=true&"
import script from "./joinus.vue?vue&type=script&lang=js&"
export * from "./joinus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f856e2",
  null
  
)

export default component.exports